import { useMutation, useQueryClient } from '@tanstack/react-query';
import moment from 'moment';
import { toast } from 'react-toastify';

import { ExitProofLogs, XML_DATE_FORMAT } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  lrn: string;
  proofOfExit: ExitProofLogs;
}

export const useSendProofOfExit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lrn, proofOfExit }: HookProps) => {
      const exitDate = proofOfExit.exitDate ? moment(proofOfExit.exitDate).format(XML_DATE_FORMAT) : null;
      const result = await apiClient.idms.sendProofOfExit.mutation({ body: { LRN: lrn, proofOfExit: { ...proofOfExit, exitDate } } });
      if (result.status !== 200) {
        throw result.body;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Proof of exit sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending proof of exit!`);
    },
  });
};
